import { vsDialog } from 'vuesax' // todo  测试

import store from '@/store/index';
import Layout from '@/layouts/main/Main.vue'
import { parseTime } from '@/utils/index'

export function createUuid() {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (S4() + S4() + S4() +  S4() + S4() +  S4() + S4() + S4());
  // guid2() // "748eea29-f842-4af9-a552-e1e1aa3ed979"
}

export function setLocalStorage(name, value, timeout) {
  localStorage.setItem(name, JSON.stringify(value));
}

//获取信息有效期
export function getLocalStorage(name) {
  let data = localStorage.getItem(name);
  if (data && data != 'undefined') {
    data = JSON.parse(localStorage.getItem(name));
    return data;
  }
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data, id = 'id', pid = 'parentId') {
  var res = []
  var temp = {}
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i]
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]['children']) {
        temp[data[k][pid]]['children'] = []
      }
      if (!temp[data[k][pid]]['_level']) {
        temp[data[k][pid]]['_level'] = 1
      }
      data[k]['_level'] = temp[data[k][pid]]._level + 1
      temp[data[k][pid]]['children'].push(data[k])
    } else {
      res.push(data[k])
    }
  }
  return res
}

/**
 *菜单是否展开
 */
export function MenuIsExpand(menu,vm){

  let open = false;
  if(menu.url == 'fundsManagement' && (vm.$route.name == 'onlinePayDetail' || vm.$route.name == 'digitalCashPayDetail' || vm.$route.name == 'walletPayDetail' || vm.$route.name == 'successSubmit'  || vm.$route.name == 'withdrawDetail' || vm.$route.name == 'telegraphicPayDetail'  || vm.$route.name == 'successWithdrawSubmit')){
    return true;
  }else if(menu.url == 'integralModule' && (vm.$route.name == 'productDetail' || vm.$route.name == 'integralRecord')){
    // 积分商城的商品详情
    return true;
  }else {
    if(menu.url == 'agent'){
      if((vm.$route.name == 'propagandas' || vm.$route.name == 'report_custom' || vm.$route.name == 'myCustomer' || vm.$route.name == 'report_subIb' || vm.$route.name == 'accountList') || vm.$route.name == 'agentFundsList' || vm.$route.name == 'agentTradeHistory' || vm.$route.name == 'symbolStatistics' || vm.$route.name == 'commissionRecord' || vm.$route.name == 'commissionOutRecord' ||  vm.$route.name == 'commissionManage' ||  vm.$route.name == 'performanceStatistics' || vm.$route.name == 'customerPerformanceStatistics' || vm.$route.name == 'subIbPerformanceStatistics'){
        // 代理模块,todo,剩下的继续添加
        return true;
      }
    }
  }
  function queryName(menu) {
    if (menu.list) {
      menu.list.forEach((innerMenu) => {
        if ((innerMenu.url.replace('/', '-')) == vm.$route.name) { open = true }
        queryName(innerMenu);
      })
    }
  };
  queryName(menu);

  return open;
}

export function download(file) {
  const link = document.createElement('a');
  link.href = file.url;
  link.download = file.fileName;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
}

// 跳转到对应的详情页 去掉一些类型,只保留mam详情页,普通详情页. todo
export function jumpDetailsPage(paramsObj) {
  let mtid = paramsObj.signalInfo.id;
  switch (paramsObj.signalInfo.businessType) {
    case 5:
      // 需要区分出模拟账户
      return paramsObj.vm.$router.push({name: 'demoDetailsSetting', params: {mtid: mtid}});
    case 0:
    case 3:
    case 6:
    case 1: // soci也归到普通账户
      // 需要区分出模拟账户
      paramsObj.vm.$router.push({name: 'generalDetails', params: {mtid: mtid}});
      break;
    case 2:
      if(paramsObj.signalInfo.tier == 1){
        paramsObj.vm.$router.push({name: 'mamMasterDetails', params: {mtid: mtid}});
      }else {
        paramsObj.vm.$router.push({name: 'mamSubDetails', params: {mtid: mtid}});
      }
      break;
  }
}

// 跳转到对应的设置页 需要调整, 去掉一些类型,只保留mam详情页,普通详情页. todo
export function jumpDetailsSettingPage(paramsObj) {
  let mtid = paramsObj.signalInfo.id;
  switch (paramsObj.signalInfo.businessType) {
    case 0:
    case 3:
    case 5:
      paramsObj.vm.$router.push({name: 'generalDetailsSetting', params: {mtid: mtid}});
      break;
    case 6:
      paramsObj.vm.$router.push({name: 'generalDealPass', params: {mtid: mtid}});
      break;
    case 2:
      if(paramsObj.signalInfo.tier == 1){
        paramsObj.vm.$router.push({name: 'mamMasterFollowSetting', params: {mtid: mtid}});
      }else {
        paramsObj.vm.$router.push({name: 'mamSubFollowSetting', params: {mtid: mtid}});
      }
      break;
  }
}


export const filterAsyncRouter = (menus) => { // 遍历后台传来的路由字符串，转换为组件对象
  const accessedRouters = menus.filter(item => {
    if (item.component) {
      // 一级菜单需要填写 'Layout'
      if (item.component === 'Layout') { // Layout组件特殊处理
        item.component = Layout;
      } else {
        const component = item.component
        item.component = loadView(component)
        item.path = item.componentName;
      }
    };
    item.meta = {
      title: item.name,
      titleEn: item.nameEn,
      icon: item.icon,
      noCache: false,
      interfaceIds: item.interfaceIds,
      sort: item.sort,
    };
    item.name = item.componentName;

    delete item.icon;
    delete item.id;
    delete item.interfaceIds;
    delete item.nameEn;

    if (item.children && item.children.length) {
      item.children = filterAsyncRouter(item.children);
    }

    return true;
  });
  return accessedRouters;
}

export const loadView = (view) => { // 路由懒加载
  return () => import(`@/views/${view}`);
}


export function getEmailAddress(email) {
  let location=''
  let hash = {
    'qq.com': 'http://mail.qq.com',
    'gmail.com': 'http://gmail.google.com',
    'sina.com': 'http://mail.sina.com.cn',
    '163.com': 'http://mail.163.com',
    '126.com': 'http://mail.126.com',
    'yeah.net': 'http://www.yeah.net/',
    'sohu.com': 'http://mail.sohu.com/',
    'tom.com': 'http://mail.tom.com/',
    'sogou.com': 'http://mail.sogou.com/',
    '139.com': 'http://mail.10086.cn/',
    'hotmail.com': 'http://www.hotmail.com',
    'live.com': 'http://login.live.com/',
    'live.cn': 'http://login.live.cn/',
    'live.com.cn': 'http://login.live.com.cn',
    '189.com': 'http://webmail16.189.cn/webmail/',
    'yahoo.com.cn': 'http://mail.cn.yahoo.com/',
    'yahoo.cn': 'http://mail.cn.yahoo.com/',
    'eyou.com': 'http://www.eyou.com/',
    '21cn.com': 'http://mail.21cn.com/',
    '188.com': 'http://www.188.com/',
    'foxmail.com': 'http://www.foxmail.com',
    'outlook.com': 'http://www.outlook.com'
    }

    let _email = email.split('@')[1];    //获取邮箱域
    if(hash.hasOwnProperty(_email)){
        location = hash[_email];
    }else{
        location = 'mail.'+ _email
    }
    return location
}
//将获取时间格式为yyyy-MM-dd的当前时间
export function getCurrentDate() {
  var date = new Date();
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
}
//将时间戳转化为24H标准时间
export function changeTimestamp(values) {
  let date = new Date(values);

  let Y = date.getFullYear();
  let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
  let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  let time = Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s;
  return time;
}

export function getNow(){
  let nowDate = new Date();
  let dateString = parseTime(nowDate,'{y}-{m}-{d}');
  return new Date(dateString);
};

// 将字符串去重后并返回一个数组
export function filterRepeatStr(str) {
  let ar2 = str.split(',');
  let array = new Array();
  let j = 0;
  for (let i = 0; i < ar2.length; i++) {
    if ((array == '' || array.toString().match(new RegExp(ar2[i], 'g')) == null) && ar2[i] != '') {
      array[j] = ar2[i];
      array.sort();
      j++;
    }
  }
  return array;
}
// 处理语言
export function filtrelang(lang, itme) {
  let result = '';
  if (lang == 'zh_CN') {
    result = itme.columnName
  } else {
    result = itme['columnName' + 'En']
  }
  return result;
}


//动态设置文字头部和icon

export function SetTitleAndIcon(res) {
  // document.title = res.siteName || '阿丽塔科技有限公司';

  let linkIcon = document.getElementById('link-icon');
  linkIcon.href = res.icon;
}
export function scrollTop() {
    let docScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if(docScrollTop != 0){
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        window.pageYOffset = 0;
    }
}


/*
 * 获取浏览器版本信息
 */
function getBrowerInfo() {
  let userAgent = window.navigator.userAgent.toLowerCase()
  let browserType = ''
  let browserVersion = ''
  let isIE = userAgent.match(/msie/) != null || userAgent.match(/trident/) != null
  if (userAgent.indexOf("firefox") > 0) {
    browserType = '火狐'
    browserVersion = userAgent.match(/firefox\/([\d.]+)/)[1]
  }
  // 浏览器类型-IE
  if (userAgent.match(/msie/) != null || userAgent.match(/trident/) != null) {
    browserType = 'IE'
    browserVersion = this.getIeVersion()
  }
  // 欧朋
  else if (window.opera || (userAgent.indexOf("opr") > 0)) {
    browserType = '欧朋'
    browserVersion = this.getOperaVersion(userAgent)
  }
  // UC
  else if (userAgent.indexOf("ubrowser") > 0) {
    browserType = 'UC'
    browserVersion = userAgent.match(/ubrowser\/([\d.]+)/)[1]
  }
  // 百度
  else if (userAgent.indexOf("bidubrowser") > 0) {
    browserType = '百度'
    browserVersion = userAgent.match(/bidubrowser\/([\d.]+)/)[1]
  }
  // 搜狗
  else if (userAgent.indexOf("metasr") > 0 || userAgent.indexOf("se 2.x") > 0) {
    browserType = '搜狗'
    // browserVersion =  userAgent.match(/metasr\/([\d.]+)/)[1]
  }
  // QQ
  else if (userAgent.indexOf("tencenttraveler") > 0) {
    browserType = 'QQ'
    browserVersion = userAgent.match(/tencenttraveler\/([\d.]+)/)[1]
  }
  // QQ
  else if (userAgent.indexOf("qqbrowser") > 0) {
    browserType = 'QQ'
    browserVersion = userAgent.match(/qqbrowser\/([\d.]+)/)[1]
  }
  // 遨游
  else if (userAgent.indexOf("maxthon") > 0) {
    browserType = '遨游'
    browserVersion = userAgent.match(/maxthon\/([\d.]+)/)[1]
  }
  // 火狐
  else if (userAgent.indexOf("firefox") > 0) {
    browserType = '火狐'
    browserVersion = userAgent.match(/firefox\/([\d.]+)/)[1]
  }
  // edge
  else if (userAgent.indexOf("edge") > 0) {
    browserType = 'Edge'
    browserVersion = userAgent.match(/edge\/([\d.]+)/)[1]
  }
  // 谷歌/360
  else if (userAgent.indexOf("chrome") > 0) {
    if (this.validate360('type', 'application/x360mmplugin')) {
      browserType = '360'
      // browserVersion =  userAgent.match(/chrome\/([\d.]+)/)[1]
    } else {
      browserType = '谷歌'
      browserVersion = userAgent.match(/chrome\/([\d.]+)/)[1]
    }
  }
  // 苹果
  else if (userAgent.indexOf("Safari") > -1) {
    browserType = 'Safari'
    browserVersion = userAgent.match(/version\/([\d.]+)/)[1]
  }
  return browserType + ' ' + browserVersion
}


export function parsePayType(payType) {
  switch (payType) {
    case 10:
      return this.$t('User.searchType1')
    case 11:
      return this.$t('User.searchType2')
    case 12:
      return this.$t('User.searchType3')
    case 13:
      return this.$t('User.searchType4')
    case 20:
      return this.$t('User.searchOutType1')
    case 21:
      return this.$t('User.searchOutType2')
    case 22:
      return this.$t('User.searchOutType3')
    case 23:
      return this.$t('User.searchOutType3')
    default:
      return this.$t('User.searchOutType4')
  }
}


export function parseStatus(type, status) {
  switch (status) {
    case 6:
      return type == 1 ? this.$t('User.searchStatus2') : this.$t('User.searchOutStatus2')
    case 99:
      return type == 1 ? this.$t('User.searchStatus3') : this.$t('User.searchOutStatus3')
    default:
      return this.$t('User.searchOutStatus1')
  }
}

/*将图片转为base64*/
export function getBase64(file){
  return new Promise(function(resolve, reject) {
    let reader = new FileReader();
    let imgResult = "";
    reader.readAsDataURL(file);
    reader.onload = function() {
      imgResult = reader.result;
    };
    reader.onerror = function(error) {
      reject(error);
    };
    reader.onloadend = function() {
      // 超过0.5M压缩
      const isLt05M = file.size / 1024 / 1024 > 0.5;
      if (isLt05M) {
        compress(reader.result,file.size).then((res) => {
          resolve(res);
        });
      } else {
        resolve(imgResult);
      }
    };
  });
}

export function compress(base64Img,fileSize){
  return new Promise(function(resolve, reject) {
    var img=new Image();
    img.src=base64Img;
    img.onload = () => {
      var width=img.width;
      var height=img.height;
      var canvas=document.createElement("canvas");
      canvas.width=width;
      canvas.height=height;
      canvas.getContext("2d").drawImage(img,0,0,width,height);
      let quality = 0.5;
      let size = fileSize / 1024 / 1024;
      if(0.5 < size && size < 1){
        quality = 0.3;
      }else if( 1 < size && size < 3){
        quality = 0.4;
      }else if( 3 < size && size < 10){
        quality = 0.5;
      }
      //在指定图片格式为 image/jpeg 或 image/webp 的情况下，可以从 0 到 1 的区间内选择图片的质量。如果超出取值范围，将会使用默认值 0.92。其他参数会被忽略。
      resolve(canvas.toDataURL('image/jpeg', quality));
    };
  });
}


export function getCustType(row){
  if(row.custType == 0){
    return this.$t('User.reportDir');
  }else if(row.custType == 1){
    return this.$t('User.reportIndir');
  }
}

export function TimeDown(totalSeconds) {
  //小时数
  var hours = Math.floor(totalSeconds / (60 * 60));
  //分钟
  var minutes = Math.floor(totalSeconds / 60 % 60);
  //秒
  var seconds = totalSeconds % 60;
  //输出到页面
  let realHours = hours < 10 ? '0'+ hours : hours;
  let realMinutes = minutes < 10 ? '0'+ minutes : minutes;
  let realSeconds = seconds < 10 ? '0'+ seconds : seconds;

  return realHours + ":" + realMinutes + ":" + realSeconds;
}


export function isIncludeMinus(string) {
  if(typeof string == 'number'){
    string = string + '';
  }
  return string && string.includes('-');
}

export function phFileter(data,vm) {
  return vm.$t(data);
};




export function getProportionPrefixList(){
  return [
    {
      value: 1,
      label: 1,
    },
    {
      value: 5,
      label: 5,
    },
    {
      value: 10,
      label: 10,
    },
    {
      value: 20,
      label: 20,
    },
    {
      value: 40,
      label: 40,
    },
    {
      value: 50,
      label: 50,
    },
    {
      value: 60,
      label: 60,
    },
    {
      value: 80,
      label: 80,
    },
    {
      value: 100,
      label: 100,
    },
  ];
}
export function getSelectList(sharePriceList,outerIndex){
  let tempArr = JSON.parse(JSON.stringify(getProportionPrefixList()));
  for (let j = sharePriceList.length - 1; j >= 0; j--) {
    for (let i = tempArr.length - 1; i >= 0; i--) {
      if(sharePriceList[j].profitValue == tempArr[i].value && j !== outerIndex){
        tempArr.splice(i,1);
      }
    }
  }
  return tempArr;
};

export function showMessage(_this,message){
  _this.$message({
    type: 'warning',
    message: message,
  });
}

export function getIsSuperIsAgentOfcustomer(userInfo){
  if(userInfo.custSource > 0 && userInfo.custType === 3){
    return false;
  }else {
    return true;
  }
}

// 策略的方式
export function getCopyType(copyType,copyValue,vm){
  if(copyType ==3 && copyValue == 999999999.99){ return '' };
  return copyType == 1 ? vm.$t('Home.forexLot') : vm.$t('multiple');
}

export function getStrategy(row, vm) {
  if(row.copyType === null) return '-'
  let name = row.copyType == 3 ? `${vm.$t('Smart_proportion')}:` : row.copyType == 2 ? `${vm.$t('fixed_proportion')}:` : `${vm.$t('fixed_lots')}:`;
  let value = row.copyValue == 999999999.99 ? `${vm.$t('no_limit')}` : row.copyValue == null ? '-': row.copyValue;
  let unit = getCopyType(row.copyType,row.copyValue, vm);
  return `${name} ${value} ${unit}` ;
}
// 启用中和待结算以及已结算列表,的开始时间和结束时间
export function getDuringDate(dateInfo){
  if(!dateInfo.beginTime) return '-';
  return dateInfo.beginTime + ' ~ ' + dateInfo.expireDate;
}


// 复制跟单-收入和支出列表-支出和收入具体
export function getPrice(row,vm){
  let leftText = '';
  switch (row.priceType) {
    case 0:
      leftText = `${vm.$t('Subscription_fee')}*${vm.$t('month')}: `;
      break;
    case 1:
      leftText = `${vm.$t('Management_fee_ratio')}*${vm.$t('Manage_funds')}: `;
      break;
    case 2:
      leftText = `${vm.$t('Performance_fee_ratio')}*${vm.$t('Follow_income')}: `;
      break;
  }
  return leftText + row.priceDetail;
}

export function setSufx(number){
  let str = '';
  if(number >= 0){
    str += '$' + number;
  }else {
    str += '-$' + Math.abs(number);
  }
  return str;
}

export function limitVideoSizeFormat(file,vm){
  const isImgFomat = [ "video/mp4",].includes(file.type);
  if(!isImgFomat){
    vm.$message.error('上传视频的格式仅限mp4');
    return false;
  }
  // 10M以内
  const isLt = file.size / 1024 / 1024 < 10;
  if (!isLt) {
    vm.$message.error('上传视频的大小不能超过10M');
    return false;
  }
  return isImgFomat && isLt;
}

export function limitVoiceSizeFormat(file,vm){

  const isImgFomat = ['audio/amr','audio/mp3','audio/mpeg'].includes(file.type);
  if(!isImgFomat){
    vm.$message.error('上传语音的格式仅限AMR\MP3');
    return false;
  }
  // 2M以内
  const isLt = file.size / 1024 / 1024 < 2;
  if (!isLt) {
    vm.$message.error('上传语音的大小不能超过2M');
    return false;
  }
  return isImgFomat && isLt;
}


//'image/bmp','image/tiff'
export function limitImageSizeFormat(file,vm){
  const isImgFomat = ['image/jpg','image/jpeg','image/png',].includes(file.type);
  if(!isImgFomat){
    vm.$message.error('上传图片的格式仅限jpg/jpeg/png');
    return false;
  }
  // 2M以内
  const isLt10M = file.size / 1024 / 1024 < 2;
  if (!isLt10M) {
    vm.$message.error('上传图片的大小不能超过2M');
    return false;
  }
  return isImgFomat && isLt10M;
}

// 将base64转为file
//   base64转file
export function base64toFile(dataBase64, filename = "file") {
  let arr = dataBase64.split(",");
  let mime = arr[0].match(/:(.*?);/)[1]; //设置file文件流的type名称
  let suffix = mime.split("/")[1]; //设置file文件流的name名称
  const bstr = window.atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], `${filename}.${suffix}`, {
    type: mime,
  });
}

// times是天为单位
export function matchTime(times,vm){
  if(times < 31){
    return times + '天';
  }else if(times){
    let intNum = Math.floor(times / 31);
    return intNum + '月';
  }else {
    let intNum = Math.floor(times / 365);
    return intNum + '年';
  }
}

export function setBodyHidden(){
  let reouterview = document.getElementById('body');
  reouterview.classList.add('hidden-scroll');
}

export function setBodyNormal(){
  let reouterview = document.getElementById('body');
  reouterview && reouterview.classList.remove('hidden-scroll');
}

export function toggleStockMaxAndValue(list){
  for (let i = 0; i < list.length; i++) {
    for (let j = 0; j < list[i].symbolGroup.length; j++) {

      if(list[i].symbolGroup[j].name === 'Stock'){
        if(list[i].symbolGroup[j].value){
          list[i].symbolGroup[j].value = list[i].symbolGroup[j].value * 100;
        }
        if(list[i].symbolGroup[j].max){
          list[i].symbolGroup[j].max = list[i].symbolGroup[j].max * 100;
        }
      }
    }
  }
}

/**
 *
 * @param SelfRuleData, 当前返佣规则
 * @param fatherRuleData, 上级返佣规则
 * @param vm, this
 * @returns {boolean}
 */
export function getRuleValidateFlag(SelfRuleData,fatherRuleData,vm){
  let pass = true;
  let reg = /^[0-9]+([.][0-9]{1}){0,1}$/;
  let regStock = /^[0-9]+([.][0-9]{0,2}){0,2}$/;
  let regCent = /^[0-9]+([.][0-9]{0,4}){0,4}$/;
  for (let i = 0; i < SelfRuleData.length; i++) {
    if(!pass){
      break;
    }
    for (let j = SelfRuleData[i].symbolGroup.length - 1; j >= 0; j--) {

      // 没有规则的情况下不用验证,max为-1,
      if(SelfRuleData[i].symbolGroup[j].max !== -1){
        // 非空验证
        if(SelfRuleData[i].symbolGroup[j].value === ''){
          pass = false;
          vm.$message.error(`${vm.$t('Please_fill_out')}${SelfRuleData[i].mt4GroupNamme} / ${SelfRuleData[i].symbolGroup[j].name}`);
          break;
        }

        if(SelfRuleData[i].mt4GroupNamme != 'Cent'){
          if(reg.test(SelfRuleData[i].symbolGroup[j].value) == false){
            // 验证最多只能有一位小数
            vm.$message.error(`${vm.$t('Cent_accounts_allow_two_decimal_places_other_accounts_allow_one_decimal_place')}`);
            pass = false;
            break;
          }
        }else {
          //Cent允许两位小数,
          if(SelfRuleData[i].symbolGroup[j].name == 'Stock'){
            if(regStock.test(SelfRuleData[i].symbolGroup[j].value) == false){
              // 验证最多只能有两位小数
              vm.$message.error(`${vm.$t('Cent_account_Stock_type_allows_two_decimal_places')}`);
              pass = false;
              break;
            }
          }else {
            if(regCent.test(SelfRuleData[i].symbolGroup[j].value) == false){
              // 验证最多只能有两位小数
              vm.$message.error(`${vm.$t('Cent_accounts_allow_two_decimal_places_other_accounts_allow_one_decimal_place')}`);
              pass = false;
              break;
            }
          }
        }

        // 添加佣金规则
        if(!fatherRuleData.length){
          if(SelfRuleData[i].symbolGroup[j].value > SelfRuleData[i].symbolGroup[j].max){
            pass = false;
            vm.$message({
              type: 'error',
              message: `${SelfRuleData[i].mt4GroupNamme}/${SelfRuleData[i].symbolGroup[j].name}${vm.$t('The_highest_can_be_set')}${vm.SelfRuleData[i].symbolGroup[j].max}`
            });
            break;
          }

        }else {
          // 编辑佣金规则
          if(SelfRuleData[i].symbolGroup[j].value > fatherRuleData[i].symbolGroup[j].value){
            pass = false;
            vm.$message({
              type: 'error',
              message: `${SelfRuleData[i].mt4GroupNamme}/${SelfRuleData[i].symbolGroup[j].name}${vm.$t('The_highest_can_be_set')}${fatherRuleData[i].symbolGroup[j].max}`
            });
            break;
          }
        }
      }
    }
  }
  return pass;
}


/**处理过的当前规则数据
 *@param SelfRuleData 当前返佣规则
 */
export function getHandleRuleData(SelfRuleData){
  let copySelfRuleData = JSON.parse(JSON.stringify(SelfRuleData));
  for (let i = 0; i < copySelfRuleData.length; i++) {

    for (let j = copySelfRuleData[i].symbolGroup.length - 1; j >= 0; j--) {
      if(copySelfRuleData[i].symbolGroup[j].name === 'Stock' ){
        if(copySelfRuleData[i].symbolGroup[j].max){
          copySelfRuleData[i].symbolGroup[j].max = copySelfRuleData[i].symbolGroup[j].max / 100;
        }

        if(copySelfRuleData[i].symbolGroup[j].value){
          copySelfRuleData[i].symbolGroup[j].value = copySelfRuleData[i].symbolGroup[j].value / 100;
        }
      }
      // 没有规则的情况下不用填写,value赋值-1
      if(copySelfRuleData[i].symbolGroup[j].max == -1){
        copySelfRuleData[i].symbolGroup.splice(j,1);
      }
    }
  }
  return copySelfRuleData;
}

export function unifyNumber(num) {
  if (num === '') {
    return 0
  } else {
    let handleNum = parseFloat(num);
    let isToFixed = handleNum.toString().includes('.') && handleNum.toString().split('.')[1].length > 2
    if (isToFixed) {
      return (Math.floor(handleNum*100)/100).toFixed(2);
    } else {
      return handleNum
    }
  }
}

//下载文件
/**
 * 通过url下载文件并对下载的文件更名
 * @param {*} url
 * @param {*} filename
 */
export const downloadFile = (url, filename) => {
  function getBlob (url) {
    return new Promise(resolve => {
      const XML = new XMLHttpRequest();
      XML.open('GET', url, true);
      XML.responseType = 'blob';
      XML.onload = () => {
        if (XML.status === 200) {
          resolve(XML.response);
        }
      };
      XML.send();
    });
  }
  //下载文件
  function saveAs (blob, filename) {
    const elelink = document.createElement("a");
    elelink.style.display = 'none';
    elelink.download = filename;
    elelink.href = window.URL.createObjectURL(blob);
    document.body.appendChild(elelink);
    elelink.click();
    document.body.removeChild(elelink);
  }
  // 调用以上方法进行下载
  getBlob(url).then(blob => {
    saveAs(blob, filename);
  });
}
